module.exports = __webpack_public_path__ + "img/value-down.5abb3f93.svg";